(function () {

function render_hero_image (root_el, image) {
  const hero_image_el = document.createElement('div');
  hero_image_el.className = 'hero_image';
  hero_image_el.style.backgroundImage = 'url('+image.url+')';
  root_el.appendChild(hero_image_el);

  const text_el = document.createElement('div');
  text_el.className = 'text';
  text_el.innerText = 'supreme warmth, comfort & durability';
  hero_image_el.appendChild(text_el);

  const button_el = document.createElement('a');
  button_el.className = 'hero_image_button';
  button_el.href = window_api_data.root_url + '/collections/wetsuits/';
  button_el.innerText = 'explore wetsuits';
  hero_image_el.appendChild(button_el);
}


function render_collection_feature (root_el, items) {
  const collection_feature_el = document.createElement('div');
  collection_feature_el.className = 'collection_feature';
  root_el.appendChild(collection_feature_el);


  for (let i=0; i<items.length; i++) {
    const item = items[i];

    const item_el = document.createElement('a');
    item_el.className = 'item';
    item_el.href = window_api_data.root_url + item.url;
    collection_feature_el.appendChild(item_el);

    const image_el = document.createElement('img');
    image_el.className = 'image';
    image_el.src = item.image.url;
    item_el.appendChild(image_el)

    const title_el = document.createElement('div');
    title_el.className = 'title';
    title_el.innerText = item.title;
    item_el.appendChild(title_el);
  }
}


function render_film_feature (root_el, props) {
  const film_feature_el = document.createElement('div');
  film_feature_el.className = 'film_feature';
  root_el.appendChild(film_feature_el);

  let video_el = document.createElement('div')
  video_el.className = 'video';
  film_feature_el.appendChild(video_el)

  let yt_video = null;

  window.YT.ready(function handle_yt_ready () {
    yt_video = new YT.Player(video_el, {
      width: 1280,
      height: 720,
      videoId: props.id,
      playerVars: {
        'autoplay': 1,
        'controls': 0,
        'modestbranding': 1,
        'loop': 1,
        'playsinline': 1,
        'mute': 1,
        'rel': 0,
        'cc_load_policy': 0,
        'iv_load_policy': 3,
      },
      events: {
        'onReady': handle_video_ready,
        'onStateChange': handle_video_state_change,
        'onApiChange': handle_video_api_change
      }
    })
  });

  // cc_load_policy is only a hint to the player, so drop the captions module
  // as well - these are silent looping backgrounds with no controls, so there
  // is nothing for a viewer to turn subtitles back on with.
  function disable_captions () {
    try {
      yt_video.unloadModule('captions')  // html5 player
      yt_video.unloadModule('cc')        // legacy player
    }
    catch (e) {
      // player not ready for module calls yet - onApiChange will retry
    }
  }

  function handle_video_ready () {
    yt_video.mute()
    disable_captions()
    yt_video.playVideo()
  }

  function handle_video_api_change () {
    disable_captions()
  }

  function handle_video_state_change (e) {
    if (e.data === YT.PlayerState.ENDED) {
      yt_video.playVideo()
    }
  }

  const title_el = document.createElement('div');
  title_el.className = 'title';
  title_el.innerText = props.title;
  film_feature_el.appendChild(title_el);

  const button_el = document.createElement('a');
  button_el.className = 'film_feature_button';
  button_el.href = window_api_data.root_url + props.href;
  button_el.innerText = props.link_text;
  film_feature_el.appendChild(button_el);
}


function render_text_feature (root_el, value) {
  const text_feature_el = document.createElement('div');
  text_feature_el.className = 'text_feature';
  text_feature_el.innerHTML = value.text;
  root_el.appendChild(text_feature_el);

  const text_el = document.createElement('div');
  text_el.className = 'text';
  text_feature_el.appendChild(text_el);

  if (value.button) {
    const button_el = document.createElement('a');
    button_el.className = 'text_feature_button';
    button_el.href = window_api_data.root_url + value.button.href;
    button_el.innerText = value.button.text;
    text_feature_el.appendChild(button_el);
  }
}


function render_hero_image_three (root_el, image) {
  const hero_image_three_el = document.createElement('div');
  hero_image_three_el.className = 'hero_image_three';
  hero_image_three_el.style.backgroundImage = 'url('+image.url+')';
  root_el.appendChild(hero_image_three_el);

  const text_el = document.createElement('div');
  text_el.className = 'text';
  text_el.innerText = 'wetsuits - built better';
  hero_image_three_el.appendChild(text_el);

  const buttons_el = document.createElement('div');
  buttons_el.className = 'buttons';
  hero_image_three_el.appendChild(buttons_el);

  {
    const button_el = document.createElement('a');
    button_el.className = 'hero_image_three_button';
    button_el.href = window_api_data.root_url + '/collections/mens-wetsuits/';
    button_el.innerText = 'mens';
    buttons_el.appendChild(button_el);
  }

  {
    const button_el = document.createElement('a');
    button_el.className = 'hero_image_three_button';
    button_el.href = window_api_data.root_url + '/collections/womens-wetsuits/';
    button_el.innerText = 'womens';
    buttons_el.appendChild(button_el);
  }

  {
    const button_el = document.createElement('a');
    button_el.className = 'hero_image_three_button';
    button_el.href = window_api_data.root_url + '/collections/kids-wetsuits/';
    button_el.innerText = 'kids';
    buttons_el.appendChild(button_el);
  }
}


function render_yulex_feature (root_el, props) {
  const yulex_feature_el = document.createElement('div');
  yulex_feature_el.className = 'yulex_feature';
  yulex_feature_el.style.backgroundImage = 'url('+props.background.url+')';
  root_el.appendChild(yulex_feature_el);

  const row_el = document.createElement('div');
  row_el.className = 'yulex_row';
  yulex_feature_el.appendChild(row_el);

  for (let i=0; i<props.images.length; i++) {
    const col_el = document.createElement('div');
    col_el.className = 'yulex_col';
    row_el.appendChild(col_el);

    const img_el = document.createElement('img');
    img_el.className = 'yulex_img';
    img_el.src = props.images[i].url;
    col_el.appendChild(img_el);
  }

  const text_el = document.createElement('div');
  text_el.className = 'text';
  text_el.innerText = 'neoprene free wetsuits';
  yulex_feature_el.appendChild(text_el);

  const button_el = document.createElement('a');
  button_el.className = 'yulex_feature_button';
  button_el.href = window_api_data.root_url + '/collections/yulex/';
  button_el.innerText = 'natural rubber wetsuits';
  text_el.appendChild(button_el);

  const bottom_text_el = document.createElement('div');
  bottom_text_el.className = 'bottom_text';
  bottom_text_el.innerText = 'providing a more ethical and responsible supply chain';
  yulex_feature_el.appendChild(bottom_text_el);
}


function render_partners (root_el, props) {
  const partners_el = document.createElement('div');
  partners_el.className = 'partners';
  partners_el.style.backgroundImage = 'url('+props.background.url+')';
  root_el.appendChild(partners_el);

  const text_el = document.createElement('div');
  text_el.className = 'text';
  text_el.innerHTML = '<p>Since 2013 our focus has been on providing a more ethical and responsible supply chain for surfers</p><p><b>Ethical Manufacturing / Responsible Materials / Compostable Packaging / No Advertising Materials</b></p><p>We support the conservation and the protection of our environment partnering with:</p>';

  partners_el.appendChild(text_el);

  const row_el = document.createElement('div');
  row_el.className = 'partners_row';
  partners_el.appendChild(row_el);

  for (let i=0; i<props.images.length; i++) {
    const link_el = document.createElement('a');
    link_el.className = 'partners_link';
    link_el.href = window_api_data.root_url + props.images[i].href;
    row_el.appendChild(link_el);

    const img_el = document.createElement('img');
    img_el.className = 'partners_img';
    img_el.src = props.images[i].url;
    link_el.appendChild(img_el);
  }
}


function render_home (root_el) {
  const home_el = document.createElement('div');
  home_el.className = 'home';
  root_el.appendChild(home_el);

  for (let i=0; i<window_api_data.blocks.length; i++) {
    const block = window_api_data.blocks[i];

    if (block.type == 'hero_image') {
      render_hero_image(home_el, block.value);
    }
    else if (block.type == 'collection_feature') {
      render_collection_feature(home_el, block.value);
    }
    else if (block.type == 'film_feature') {
      render_film_feature(home_el, block.value);
    }
    else if (block.type == 'text_feature') {
      render_text_feature(home_el, block.value);
    }
    else if (block.type == 'hero_image_three') {
      render_hero_image_three(home_el, block.value);
    }
    else if (block.type == 'yulex_feature') {
      render_yulex_feature(home_el, block.value);
    }
    else if (block.type == 'partners') {
      render_partners(home_el, block.value);
    }
  }
}

window.render_home = render_home;


})()
